import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ErrorService } from "@root/shared/service/error.service";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
  HttpParams
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { ERROR_CODE } from "@root/config";
// import { NzMessageService } from "ng-zorro-antd/message";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private errorService: ErrorService,
    // private messageService: NzMessageService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // let filteredParams = new HttpParams();
    // const keys = req.params.keys();
    // keys.forEach(key => {
    //   filteredParams = filteredParams.append(key, req.params.get(key));
    // });
    const url = req.url;
    // req.clone({ params: filteredParams });
    return next.handle(req).pipe(
      filter(event => event instanceof HttpResponse),
      tap((event: HttpResponse<any>) => {
        if (!event.body) {
          return;
        }
        const auth = req.headers.get('auth');
        if (auth === 'no') {
          return of(event);
        }

        if (event.body.error_code === ERROR_CODE.USER_AUTH_FAILED) {
          if (location.pathname !== '/app/login') {
            this.router.navigate(["/app/login"], {
              queryParams: { page_type: 'register', redirect: location.pathname + location.search }
            });
          }
        } else if (event.body.error_code === ERROR_CODE.CODE_PRODUCT_EXPIRED) {
          if (!this.inMemberBlackList(url)) {
            this.router.navigate(["/app/properties"]);
          }
        } else if (
          event.body.error_code &&
          event.body.error_code !== ERROR_CODE.SUCCESS &&
          event.body.error_code !== ERROR_CODE.USER_NEED_FINISH_INFO &&
          event.body.error_code !== -1 &&
          !this.inErrorAlertWhiteList(url)
        ) {
          this.errorService.displayLocalError(event.body);
        }
      })
    );
  }

  inErrorAlertWhiteList(url) {
    const whiteUrls = [
      "/api/reservation/widget",
      "/api/thirdparty/account_login"
    ];

    return whiteUrls.includes(url);
  }

  inMemberBlackList(url) {
    const blackUrls = [
      "/api/reservation/widget",
      "/api/calendar/holiday",
      "/api/calendar/quick_location_date",
      "api/stat/v2/transaction/detail_list",
      "api/stat/v2/transaction/operator_name_list",
      "api/transaction/get_currency",
      "api/house_relation/thirdparty_house_list",
      "api/house_relation/hostex_list",
      "api/calendar/quote",
      '/api/sub_account/list',
      '/api/role/list'
    ];

    return blackUrls.includes(url);
  }
}
